import { keyframes } from "styled-components";

export const crossFadeIn = keyframes`
  0% {
    opacity: 0;
  }
  75% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const crossFadeOut = keyframes`
  0% {
    opacity: 1;
  }
  75% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
`;

const DOT_OFFSET = 7; // Match index.js DOT_OFFSET

export const beforeDotCollapsing = keyframes`
  0% {
    transform: translateY(-${DOT_OFFSET}px);
  }
  50% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(0);
  }
`;

export const beforeDotExpanding = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-${DOT_OFFSET}px);
  }
`;

export const afterDotCollapsing = keyframes`
  0% {
    transform: translateY(${DOT_OFFSET}px);
  }
  50% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(0);
  }
`;

export const afterDotExpanding = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(${DOT_OFFSET}px);
  }
`;

export const beforeCrossExpanding = keyframes`
  0% {
    height: 4px;
    transform: rotate(-45deg);
  }
  50% {
    height: 4px;
    transform: rotate(-45deg);
  }
  100% {
    height: 18px;
    transform: translate(0, -7px) rotate(-45deg);
  }
`;

export const beforeCrossCollapsing = keyframes`
  0% {
    height: 18px;
    transform: translate(0, -7px) rotate(-45deg);
  }
  50% {
    height: 4px;
    transform: rotate(-45deg);
  }
  100% {
    height: 4px;
    transform: rotate(-45deg);
  }
`;

export const afterCrossExpanding = keyframes`
  0% {
    height: 4px;
    transform: rotate(45deg);
  }
  50% {
    height: 4px;
    transform: rotate(45deg);
  }
  100% {
    height: 18px;
    transform: translate(0, -7px) rotate(45deg);
  }
`;

export const afterCrossCollapsing = keyframes`
  0% {
    height: 18px;
    transform: translate(0, -7px) rotate(45deg);
  }
  50% {
    height: 4px;
    transform: rotate(45deg);
  }
  100% {
    height: 4px;
    transform: rotate(45deg);
  }
`;
